import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Api from '../api/api';
import Loader from '../shared/loader';
import roleUtilities from '../../utilities/roleUtilities';
import { ClickToEditInput } from '../shared/clickToEditInput';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import stringHelpers from '../../utilities/stringHelpers';
import { ErrorModal } from '../../utilities/errorModal';

function SiteContravention(props) {
    const history = useHistory()
    const contraventionId = props.match.params.contraventionId;
    const siteId = props.match.params.siteId
    const [siteContraventions, setSiteContraventions] = useState(null);
    const [selectedContravention, setSelectedContravention] = useState(null);

    const [reducedChargeOverride, setReducedChargeOverride] = useState(null);
    const [reducedChargeDaysOverride, setReducedChargeDaysOverride] = useState(null);
    const [fullChargeAmountOverride, setFullChargeAmountOverride] = useState(null);
    const [fullChargeDaysOverride, setFullChargeDaysOverride] = useState(null);
    const [status, setStatus] = useState(false);

    const [siteUrl, setSiteUrl] = useState("");
    const [site, setSite] = useState(null);
    const [isLoading, setIsLoading] = useState(false)
    const [errorMessage, setErrorMessage] = useState(null)

    const submit = function () {
        if (selectedContravention) {
            Api.editSiteContravention(
                (data) => {
                    if (data.isError) {
                        console.log(data.errorMessage)
                        setErrorMessage(data.errorMessage)
                    } else {
                        history.push(siteUrl)
                    }
                },
                (error) => {
                    console.log(error);
                    setErrorMessage(error.errorMessage)
                    getSiteContraventions();
                },
                selectedContravention.id,
                reducedChargeOverride === '' ? null : reducedChargeOverride,
                reducedChargeDaysOverride === '' ? null : reducedChargeDaysOverride,
                fullChargeAmountOverride === '' ? null : fullChargeAmountOverride,
                fullChargeDaysOverride === '' ? null : fullChargeDaysOverride,
                status,
                props.organisationId,
                siteId,
                props.token
            )
        }
    };

    const getContravention = function () {
        setIsLoading(true)
        Api.getContravention(
            (data) => {
                setSelectedContravention(data)
                setIsLoading(false)
            },
            (error) => {
                console.log(error)
                setIsLoading(false)
            },
            props.organisationId,
            contraventionId,
            props.token
        )
    };

    const getSiteContraventions = function () {
        setIsLoading(true)
        Api.getSiteContraventions(
            (data) => {
                setSiteContraventions(data)
                setIsLoading(false)
            },
            (error) => {
                console.log(error)
                setIsLoading(false)
            },
            props.organisationId,
            siteId,
            props.token,
        )
    };

    useEffect(() => {
        if (site !== null) {
            setSiteUrl("/organisation/" + props.organisationId + "/client/" + site.clientId + "/site/" + siteId)
        }
    }, [site]);

    useEffect(() => {
        if (contraventionId !== undefined) {
            getContravention();
            getSiteContraventions();
        }

        if (site === null && siteId !== null) {
            Api.getSite(
                (data) => setSite(data),
                (error) => console.log(error),
                siteId,
                props.organisationId,
                props.token
            )
        }
    }, []);

    useEffect(() => {
        if (siteContraventions !== null && selectedContravention) {
            const siteContravention = siteContraventions.find(
                item => contraventionId === item.contraventionId
            )
            if (siteContravention !== undefined) {
                setReducedChargeOverride(siteContravention.reducedChargeAmount)
                setReducedChargeDaysOverride(siteContravention.reducedChargeDays)
                setFullChargeAmountOverride(siteContravention.fullChargeAmount)
                setFullChargeDaysOverride(siteContravention.fullChargeDays)
                setStatus(siteContravention.isActive)
            }
            else {
                setReducedChargeOverride(null)
                setReducedChargeDaysOverride(null)
                setFullChargeAmountOverride(null)
                setFullChargeDaysOverride(null)
            }
        }
    }, [siteContraventions, selectedContravention]);

    return (
        <>{isLoading && <Loader />}{selectedContravention && selectedContravention !== null && <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="card mb-3">
                            {(!roleUtilities.isOrganisationProcessor(props.user, props.organisationId) && !roleUtilities.isThirdPartyProcessor(props.user, props.organisationId) && !roleUtilities.isThirdPartyManager(props.user, props.organisationId)) && <div className="card-header">
                                <div className="row align-items-center">
                                    <div className="col">
                                        <h5 className="mb-0">Site Contravention - {selectedContravention.name}</h5>
                                    </div>
                                    <Link className="btn btn-falcon-default btn-sm mr-3 py-1" type="button" to={siteUrl}><i className="fas fa-reply"></i> Back</Link>
                                </div>
                            </div>}
                            
                                <div className="card-body bg-light border-top details-container">
                                    <div className="row">
                                        <div className=" col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mt-1 mb-1">Status</p>
                                        </div>
                                        <div className=" col-md-6 col-12 custom-control mt-1 custom-switch">
                                            <input className="custom-control-input" type="checkbox" id="status" checked={status} onChange={() => setStatus(!status)} />
                                            <label className="custom-control-label custom-toggle ml-3 " htmlFor="status"></label>
                                            {status && <>Active</>}{!status && <>Deactivated</>}
                                        </div>
                                    </div>
                                    <div className="row mb-1">
                                        <div className=" col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mt-1 mb-1">Reduced Charge Amount</p>
                                        </div>
                                        <div className="col-md-3 col-12 d-flex">
                                            <ClickToEditInput
                                                key="reduced-charge-amount"
                                                modeOverride={reducedChargeOverride !== null}
                                                type="number"
                                                reset={() => setReducedChargeOverride(null)}
                                                value={reducedChargeOverride ?? selectedContravention.reducedChargeAmount}
                                                setValue={value => setReducedChargeOverride(value === '' ? '' : Number(value))}
                                                editModeTooltip="Reset to default"
                                                readonlyModeTooltip="Override for this site"
                                            />
                                        </div>
                                    </div>
                                    <div className="row mb-1">
                                        <div className=" col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mt-1 mb-1">Reduced Charge Days</p>
                                        </div>
                                        <div className="col-md-3 col-12">
                                            <ClickToEditInput
                                                key="reduced-charge-days"
                                                modeOverride={reducedChargeDaysOverride !== null}
                                                type="number"
                                                reset={() => setReducedChargeDaysOverride(null)}
                                                value={reducedChargeDaysOverride ?? selectedContravention.reducedChargeDays}
                                                setValue={value => setReducedChargeDaysOverride(value === '' ? '' : Number(value))}
                                                editModeTooltip="Reset to default"
                                                readonlyModeTooltip="Override for this site"
                                            />
                                        </div>
                                    </div>
                                    <div className="row mb-1">
                                        <div className=" col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mt-1 mb-1">Full Charge Amount</p>
                                        </div>
                                        <div className="col-md-3 col-12">
                                            <ClickToEditInput
                                                key="full-charge-amount"
                                                modeOverride={fullChargeAmountOverride !== null}
                                                type="number"
                                                reset={() => setFullChargeAmountOverride(null)}
                                                value={fullChargeAmountOverride ?? selectedContravention.fullChargeAmount}
                                                setValue={value => setFullChargeAmountOverride(value === '' ? '' : Number(value))}
                                                editModeTooltip="Reset to default"
                                                readonlyModeTooltip="Override for this site"
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className=" col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mt-1 mb-1">Full Charge Days</p>
                                        </div>
                                        <div className="col-md-3 col-12">
                                            <ClickToEditInput
                                                key="full-charge-days"
                                                modeOverride={fullChargeDaysOverride !== null}
                                                type="number"
                                                reset={() => setFullChargeDaysOverride(null)}
                                                value={fullChargeDaysOverride ?? selectedContravention.fullChargeDays}
                                                setValue={value => setFullChargeDaysOverride(value === '' ? '' : Number(value))}
                                                editModeTooltip="Reset to default"
                                                readonlyModeTooltip="Override for this site"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer border-top ">
                                    <div className="row client-edit-buttons">
                                        <div className="col-6 col-sm-auto ml-auto pl-0">
                                            <div id="dashboard-actions">
                                                <Link className="btn btn-falcon-default btn-sm" to={siteUrl}><i className="fas fa-times"></i> Cancel</Link>
                                                <button type="button" className="btn btn-success btn-sm ml-2" onClick={() => submit()}>
                                                    <i className="fas fa-check"></i> Confirm</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            {!stringHelpers.isNullOrEmpty(errorMessage) && <ErrorModal message={errorMessage} onHide={() => setErrorMessage(null)} />}
        </>}
        </>
    )
}
export default SiteContravention;